export default __webpack_public_path__ + "static/media/Mark-4-HUD-Pop-Up (3 Layers).7ffee9e6.jpg";